import { useEffect, useRef, useState } from 'react';

/**
 * Lazily loads the chat widget bundle (`@liquidweb-dev/lw-chat-ui`), which
 * registers the `<chat-widget>` and `<methodic-widget>` custom elements.
 * @param enabled whether the bundle should be loaded
 * @returns whether the bundle has finished loading
 */
export default function useChatWidgetBundle(enabled: boolean): {
	isReady: boolean;
} {
	const [isReady, setIsReady] = useState(false);
	const isReadyRef = useRef(isReady);
	isReadyRef.current = isReady;

	useEffect(() => {
		if (isReadyRef.current || !enabled) return undefined;

		let isCancelled = false;

		import('components/ChatGate/chatWidgetBundle')
			.then(() => {
				if (!isCancelled) setIsReady(true);
			})
			.catch((error) => {
				if (!isCancelled) {
					// eslint-disable-next-line no-console
					console.error(
						new Error('Failed to load the chat widget bundle', {
							cause: error,
						}),
					);
				}
			});

		return () => {
			isCancelled = true;
		};
	}, [enabled]);

	return { isReady };
}
